import { hasActiveProductsToBeDisplayed } from "@qgiv/p2p-registration";
import {
    getPaymentTypeInitialValue,
    getMatchingGiftsInitialValues,
} from "@qgiv/core-donor";

const getShippingInitialValues = (settings) => {
    const { products = [] } = settings;

    const hasStoreItemsOnRegistration =
        hasActiveProductsToBeDisplayed(products);

    if (hasStoreItemsOnRegistration) {
        return {
            Shipping_Address_Use_Mailing: true,
            Shipping_First_Name: "",
            Shipping_Last_Name: "",
            Shipping_Address: "",
            Shipping_Address_2: "",
            Shipping_City: "",
            Shipping_State: "",
            Shipping_Zip: "",
            Shipping_Country: "",
            Shipping_Phone: "",
            Shipping_Method: "",
        };
    } else {
        return {};
    }
};

const getPrivacyOptionsInitialValues = (settings) => {
    const { formSettings } = settings;
    const { isStandardDonationForm = 0 } = formSettings;

    if (isStandardDonationForm) {
        return {
            Do_Not_Show_Name: false,
            Do_Not_Show_Amount: false,
            // -------------------------------------------------------------------------
            // TODO: Privacy_Display_Name and Privacy_Display_Amount are updated with the
            // inverted Do_Not_Show_Name and Do_Not_Show_Amount during submission.
            // Once we are ready to move to system fields, we will no longer need the
            // Privacy_Display initial values. Instead we will use the Do_Not_Show until
            // submission like we do in the OneForm™.
            // // -------------------------------------------------------------------------
        };
    }
    return {
        Privacy_Display_Name: true,
        Privacy_Display_Amount: true,
    };
};

export const getInitialValues = (
    settings,
    formDataValues = {},
    savedRegistrationValues = {},
) => {
    const {
        formSettings: {
            enableAchPayments,
            enableCCPayments,
            enablePaypalPayments,
            enableMatching,
            defaultCountry,
        },
        p2pSettings: { matchingType },
    } = settings;

    const values = {
        // Donation Amount
        Donation_Amount: "",
        // Gift Assist,
        Gift_Assist: false,
        // Payment Fields
        Payment_Type: getPaymentTypeInitialValue({
            enableAchPayments,
            enableCCPayments,
            enablePaypalPayments,
        }),
        Account_Number: "",
        Routing_Number: "",
        PayPal_Token: "",
        PayPal_Payer_ID: "",
        PayPal_Agreement_ID: "",
        PayPal_Is_Venmo: false,
        Apple_Pay_Token: "",
        Save_Payment: false,
        Payment_Nickname: "",
        // Billing Fields
        Billing_Address_Use_Mailing: true,
        Billing_Address: "",
        Billing_Address_2: "",
        Billing_City: "",
        Billing_State: "",
        Billing_Zip: "",
        Billing_Country: defaultCountry ? defaultCountry : "US",
        Commitment_Agreement: false,
        // Shipping Fields
        ...getShippingInitialValues(settings),

        // -------------------------------------------------------------------------
        // TODO: Update this to be dynamic once we're ready to use stored payments
        // -------------------------------------------------------------------------
        // Donor Account Stored Payment
        Stored_Payment: false,
        Promo_Codes: [],
        // Optional Privacy Options:
        ...getPrivacyOptionsInitialValues(settings),

        // Matching Gifts
        ...getMatchingGiftsInitialValues(enableMatching, matchingType),
    };

    // We can have three values objects we want to layer in this order
    // 1. initial values from settings
    // 2. form data values from previous form data (DataDome interaction)
    // 3. saved values previously entered from this form

    const initialValues = {
        ...values,
        ...formDataValues,
        ...savedRegistrationValues,
    };

    return initialValues;
};
